import * as React from "react";
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import * as globals from "../globals";
import * as locals from "./locals";
import * as utilities from "./utilities";
import * as moment from "moment";

export default function Vert(props) {
  //  collect authors
  const authors = utilities.collectAuthors(props.authors);
  return (
    <div
      css={css`
        display: block;
        padding: 10px;
        box-shadow: ${globals.cardShadow};
        background-color: #2e2e2e;
        color: #fff;
      `}
    >
      <a href={props.as} style={{ textDecoration: "none" }}>
        <img
          css={css`
            width: 100%;
            margin: auto;
          `}
          src={props.imageurl}
        />
      </a>
      <h4
        css={css`
          margin: 2px 0;

          font-family: Arimo;
          font-style: normal;
          font-weight: normal;
          font-size: 8px;
          text-align: right;
        `}
      >
        {props.photographer}
      </h4>
      <span>
        <a
          href={props.category.as}
          css={css`
            text-decoration: none;
            color: #01a5ff;
            vertical-align: middle;

            &:hover {
              text-decoration: underline;
            }
          `}
        >
          <h2
            css={css`
              margin: 0;
              font-family: Source Sans Pro;
              font-style: normal;
              font-weight: bold;
              font-size: 14px;
              text-transform: uppercase;
              display: inline;
            `}
          >
            {props.category.name}
          </h2>
        </a>
        <span
          css={css`
            margin: 0;
            vertical-align: middle;
          `}
        >
          &nbsp;|&nbsp;
        </span>
        <span
          css={css`
            margin: 0;
            font-family: Source Sans Pro, sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 11px;
            line-height: 14px;
          `}
        >
          {moment(props.date).format("MMMM Do, h:mma")}
        </span>
      </span>
      <a href={props.as} style={{ textDecoration: "none" }}>
        <h1
          css={css`
            margin: 2px 0 4px;
            ${locals.headline}
            color: #fff
          `}
          dangerouslySetInnerHTML={{ __html: props.headline }}
        />
        <p
          css={css`
            margin: 0 0 5px;
            ${locals.excerpt}
            color: #fff;
          `}
          dangerouslySetInnerHTML={{ __html: props.excerpt }}
        />
      </a>
      <h3
        css={css`
          margin: 0;

          font-family: Arimo;
          font-style: normal;
          font-weight: bold;
          font-size: 11px;

          color: #fff;
        `}
      >
        By {authors}
      </h3>
    </div>
  );
}
